export default __webpack_public_path__ + "static/media/Group.504c20d8.png";